import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi, useAuth } from '../../../hooks';
import { ChartNote } from "../../types";

type PayloadProps = {
  meeting_id: number
  note_type: string
};

export const useCreateMeetingNote = (onCreateSuccess?: (date: ChartNote) => void) => {
  const queryClient = useQueryClient();
  const { api } = useApi();
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ( payload : PayloadProps ) => {
      return await api({
        route: '/private/coach-meeting-notes/',
        method: 'POST',
        token: userToken,
        payload,
      })
    },

    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['hc-meeting-notes']
      })

      onCreateSuccess?.(data)
    }
  })

  return { mutation }
}